import { z } from 'zod';

export const publicationCaptureModeOptions = ['realtime', 'snapshot'] as const;
export const publicationCaptureModeSchema = z.enum(publicationCaptureModeOptions);
export type PublicationCaptureMode = z.infer<typeof publicationCaptureModeSchema>;

export const authTypeOptions = ['none', 'password'] as const;
export const authTypeSchema = z.enum(authTypeOptions);
export type AuthType = z.infer<typeof authTypeSchema>;

export const dataExposurePolicySchema = z
  .object({
    hiddenFieldIds: z.array(z.string()),
  })
  .strict();
export type DataExposurePolicy = z.infer<typeof dataExposurePolicySchema>;

export const publicationConfigSchema = z.record(z.string(), z.unknown());
export type PublicationConfig = z.infer<typeof publicationConfigSchema>;

export const publicationSelectSchema = z.object({
  id: z.number().int(),
  organizationId: z.string(),
  visualizationId: z.number().int(),
  urlToken: z.string(),
  userId: z.string(),
  captureMode: publicationCaptureModeSchema,
  authType: authTypeSchema,
  passwordHash: z.string().nullable(),
  authVersion: z.number().int(),
  dataExposurePolicy: dataExposurePolicySchema,
  config: publicationConfigSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type PublicationSelect = z.infer<typeof publicationSelectSchema>;
